/**
 * `<NarrativeOverlay />` — placeholder narrative banner above the
 * Surface 1 walkthrough.
 *
 * Per PR #210 §5.3 + §6 multi-discipline framework: narrative
 * scripting is CTO + content-collaborator territory. DEV5's scope is
 * the structural overlay component + layout integration with the
 * production `<App />`; the actual narrative copy gets tuned by
 * content-collaborators ahead of June 9 ship.
 *
 * v1 placeholder copy directs the demo viewer to walk the 3-scene
 * minimum-viable path (Activation → Aggregation → Patient Projection)
 * via the existing nav buttons. Per-scene narrative replaces this
 * static guidance once the wrapper observes view transitions
 * (deferred — would require an `onViewChange` extension to App).
 *
 * **Patient-Facing Terms v1.3 doctrinal-copy gate** (coord issue #42)
 * does NOT apply here — this is demo-viewer-facing narrative for
 * state Medicaid Directors, not patient-facing copy. PFT v1.3 governs
 * the PHG client's patient-facing copy (which already encodes
 * placeholders inside `@shn/phg-client-web`).
 */

import * as React from 'react';

export function NarrativeOverlay(): React.ReactElement {
  return (
    <aside
      aria-label="Walkthrough guide"
      style={{
        background: '#f5f5f0',
        borderBottom: '1px solid #ccc',
        padding: '0.75rem 1rem',
        fontSize: '0.95rem',
      }}
    >
      <p style={{ margin: 0 }}>
        <strong>Smart Health account — patient walkthrough.</strong> A
        5-minute click-through of the patient experience using
        synthetic data. No real patient is depicted. Walk through the
        scenes in order via the navigation above:{' '}
        <em>Activation</em> &rarr; <em>Aggregation</em> &rarr;{' '}
        <em>Projection</em>. Narrative scripting will be tuned by
        content collaborators ahead of the June 9 ship.
      </p>
    </aside>
  );
}
